import {
  alchemyLogo,
  amazonEc2Logo,
  amazonRdsLogo,
  amazonS3Logo,
  amazonWebServices2Logo,
  apolloLogo,
  auth0Logo,
  bitriseLogo,
  bullmqLogo,
  chargebeeLogo,
  cloudFrontLogo,
  cryptoCompareLogo,
  cssLogo,
  dockerLogo,
  docuSignLogo,
  draftJsLogo,
  elastiCacheLogo,
  elixirLogo,
  emberLogo,
  ethereumLogo,
  gitlabLogo,
  googleAnalyticsLogo,
  googleCalendarLogo,
  graphqlLogo,
  htmlLogo,
  intercomLogo,
  jestLogo,
  jsonapiLogo,
  koaLogo,
  metaMaskLogo,
  newRelicLogo,
  nodejsLogo,
  oneSignalLogo,
  paypalLogo,
  phoenixLogo,
  plaidLogo,
  podioLogo,
  postgisLogo,
  postgresqlLogo,
  pusherLogo,
  railsLogo,
  reactLogo,
  recaptchaLogo,
  redisLogo,
  reduxLogo,
  reduxSagaLogo,
  rubyLogo,
  rubyOnRailsLogo,
  sendgridLogo,
  sentryLogo,
  sequelizeLogo,
  sidekiqLogo,
  solidityLogo,
  storeonLogo,
  stripeLogo,
  telegramLogo,
  transferWizeLogo,
  truffleLogo,
  trustWalletLogo,
  twilioLogo,
  unityLogo,
  web3Logo,
  webpackLogo,
  worklairSupportWidgetLogo,
  zoomLogo,
} from 'Assets/_Legacy/Technologies'

export const TECH_NAMES = {
  ALCHEMY: 'Alchemy',
  AMAZON_EC2: 'Amazon EC2',
  AMAZON_RDS: 'Amazon RDS',
  AMAZON_S3: 'Amazon S3',
  ANDROID: 'Android',
  APOLLO: 'Apollo',
  AUTH0: 'Auth0',
  AWS: 'AWS',
  BITRISE: 'Bitrise',
  BULL_MQ: 'BullMQ',
  CHARGEBEE: 'Chargebee',
  CLOUD_FRONT: 'CloudFront',
  CRYPTO_COMPARE: 'CryptoCompare',
  CSS: 'CSS',
  DOCKER: 'Docker',
  DOCU_SIGN: 'DocuSign',
  DRAFT_JS: 'DraftJs',
  ELASTI_CACHE: 'ElastiCache',
  ELIXIR: 'Elixir',
  EMBER_JS: 'EmberJs',
  ETHEREUM: 'Ethereum',
  GIT_LAB: 'GitLab',
  GOOGLE_ANALYTICS: 'Google Analytics',
  GOOGLE_CALENDAR: 'Google Calendar',
  GRAPH_QL: 'GraphQL',
  HTML: 'HTML',
  INTERCOM: 'Intercom',
  IOS: 'iOS',
  JEST: 'Jest',
  JSON_API: 'JSON-API',
  KOA: 'Koa',
  METAMASK: 'Metamask',
  NEW_RELIC: 'new Relic',
  NODE_JS: 'Node.js',
  ONE_SIGNAL: 'One Signal',
  PAY_PAL: 'PayPal',
  PHOENIX: 'Phoenix',
  PLAID: 'Plaid',
  PODIO: 'Podio',
  POSTGRE_SQL: 'PostgreSQL',
  POST_GIS: 'PostGIS',
  PUSHER_JS: 'PusherJS',
  RAILS: 'Rails',
  REACT: 'React',
  REACT_NATIVE: 'React Native',
  REDIS: 'Redis',
  REDUX: 'Redux',
  REDUX_SAGA: 'Redux Saga',
  RE_CAPTCHA: 'reCaptcha',
  RUBY: 'Ruby',
  RUBY_ON_RAILS: 'Ruby on Rails',
  SEND_GRID: 'SendGrid',
  SENTRY: 'Sentry',
  SEQUELIZE: 'Sequelize',
  SIDEKIQ: 'Sidekiq',
  SOLIDITY: 'Solidity',
  STOREON: 'Storeon',
  STRIPE: 'Stripe',
  TELEGRAM: 'Telegram',
  TRANSFER_WISE: 'TransferWise',
  TRUFFLE: 'Truffle',
  TRUST_WALLET: 'TrustWallet',
  TWILIO: 'Twilio',
  UNITY: 'Unity',
  WEB3: 'Web3',
  WEB: 'Web',
  WEBPACK: 'Webpack',
  WORKLAIR_SUPPORT_WIDGET: 'Worklair Support Widget',
  ZOOM: 'Zoom',
}

export const TECHNOLOGIES = [
  { name: TECH_NAMES.ALCHEMY, logo: alchemyLogo },
  { name: TECH_NAMES.AMAZON_EC2, logo: amazonEc2Logo },
  { name: TECH_NAMES.AMAZON_RDS, logo: amazonRdsLogo },
  { name: TECH_NAMES.AMAZON_S3, logo: amazonS3Logo },
  { name: TECH_NAMES.ANDROID, logo: null },
  { name: TECH_NAMES.APOLLO, logo: apolloLogo },
  { name: TECH_NAMES.AUTH0, logo: auth0Logo },
  { name: TECH_NAMES.AWS, logo: amazonWebServices2Logo },
  { name: TECH_NAMES.BITRISE, logo: bitriseLogo },
  { name: TECH_NAMES.BULL_MQ, logo: bullmqLogo },
  { name: TECH_NAMES.CHARGEBEE, logo: chargebeeLogo },
  { name: TECH_NAMES.CLOUD_FRONT, logo: cloudFrontLogo },
  { name: TECH_NAMES.CRYPTO_COMPARE, logo: cryptoCompareLogo },
  { name: TECH_NAMES.CSS, logo: cssLogo },
  { name: TECH_NAMES.DOCKER, logo: dockerLogo },
  { name: TECH_NAMES.DOCU_SIGN, logo: docuSignLogo },
  { name: TECH_NAMES.DRAFT_JS, logo: draftJsLogo },
  { name: TECH_NAMES.ELASTI_CACHE, logo: elastiCacheLogo },
  { name: TECH_NAMES.ELIXIR, logo: elixirLogo },
  { name: TECH_NAMES.EMBER_JS, logo: emberLogo },
  { name: TECH_NAMES.ETHEREUM, logo: ethereumLogo },
  { name: TECH_NAMES.GIT_LAB, logo: gitlabLogo },
  { name: TECH_NAMES.GOOGLE_ANALYTICS, logo: googleAnalyticsLogo },
  { name: TECH_NAMES.GOOGLE_CALENDAR, logo: googleCalendarLogo },
  { name: TECH_NAMES.GRAPH_QL, logo: graphqlLogo },
  { name: TECH_NAMES.HTML, logo: htmlLogo },
  { name: TECH_NAMES.INTERCOM, logo: intercomLogo },
  { name: TECH_NAMES.IOS, logo: null },
  { name: TECH_NAMES.JEST, logo: jestLogo },
  { name: TECH_NAMES.JSON_API, logo: jsonapiLogo },
  { name: TECH_NAMES.KOA, logo: koaLogo },
  { name: TECH_NAMES.METAMASK, logo: metaMaskLogo },
  { name: TECH_NAMES.NEW_RELIC, logo: newRelicLogo },
  { name: TECH_NAMES.NODE_JS, logo: nodejsLogo },
  { name: TECH_NAMES.ONE_SIGNAL, logo: oneSignalLogo },
  { name: TECH_NAMES.PAY_PAL, logo: paypalLogo },
  { name: TECH_NAMES.PHOENIX, logo: phoenixLogo },
  { name: TECH_NAMES.PODIO, logo: podioLogo },
  { name: TECH_NAMES.POSTGRE_SQL, logo: postgresqlLogo },
  { name: TECH_NAMES.POST_GIS, logo: postgisLogo },
  { name: TECH_NAMES.PUSHER_JS, logo: pusherLogo },
  { name: TECH_NAMES.RAILS, logo: railsLogo },
  { name: TECH_NAMES.REACT, logo: reactLogo },
  { name: TECH_NAMES.REACT_NATIVE, logo: reactLogo },
  { name: TECH_NAMES.REDIS, logo: redisLogo },
  { name: TECH_NAMES.REDUX, logo: reduxLogo },
  { name: TECH_NAMES.REDUX_SAGA, logo: reduxSagaLogo },
  { name: TECH_NAMES.RE_CAPTCHA, logo: recaptchaLogo },
  { name: TECH_NAMES.RUBY, logo: rubyLogo },
  { name: TECH_NAMES.RUBY_ON_RAILS, logo: rubyOnRailsLogo },
  { name: TECH_NAMES.SEND_GRID, logo: sendgridLogo },
  { name: TECH_NAMES.SENTRY, logo: sentryLogo },
  { name: TECH_NAMES.SEQUELIZE, logo: sequelizeLogo },
  { name: TECH_NAMES.SIDEKIQ, logo: sidekiqLogo },
  { name: TECH_NAMES.SOLIDITY, logo: solidityLogo },
  { name: TECH_NAMES.STOREON, logo: storeonLogo },
  { name: TECH_NAMES.STRIPE, logo: stripeLogo },
  { name: TECH_NAMES.TELEGRAM, logo: telegramLogo },
  { name: TECH_NAMES.TRANSFER_WISE, logo: transferWizeLogo },
  { name: TECH_NAMES.TRUFFLE, logo: truffleLogo },
  { name: TECH_NAMES.TRUST_WALLET, logo: trustWalletLogo },
  { name: TECH_NAMES.TWILIO, logo: twilioLogo },
  { name: TECH_NAMES.UNITY, logo: unityLogo },
  { name: TECH_NAMES.WEB, logo: null },
  { name: TECH_NAMES.WEB3, logo: web3Logo },
  { name: TECH_NAMES.WEBPACK, logo: webpackLogo },
  { name: TECH_NAMES.ZOOM, logo: zoomLogo },
  { name: TECH_NAMES.PLAID, logo: plaidLogo },
  { name: TECH_NAMES.WORKLAIR_SUPPORT_WIDGET, logo: worklairSupportWidgetLogo },
]
